export enum TempleActionTypes {
    API_RESPONSE_SUCCESS = '@@temple/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@temple/API_RESPONSE_ERROR',
    GET_TEMPLES = '@@temple/GET_TEMPLES',
    GET_TEMPLE_DETAILS = '@@temple/GET_TEMPLE_DETAILS',
    UPDATE_TEMPLE = '@@temple/UPDATE_TEMPLE',
    ADD_TEMPLE = '@@temple/ADD_TEMPLE',
    DELETE_TEMPLE = '@@temple/DELETE_TEMPLE',
    RESET = '@@temple/RESET',
}
